import globalText from "../../../styles/globalText"

const texts = {
    ...globalText,
    classicConnexion: "Avec mes identifiants",
    separatorLabel: "OU",
}

export default texts
